import React from 'react';
import { Link, useTranslate, useGetList, useGetIdentity } from 'react-admin';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import moment from 'moment';

import AdminWarningCards from './AdminWarningCards';

const NOW = moment();

const cardSx = (theme) => ({
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: theme.palette.mode === 'dark' ? theme.palette.warning.dark : theme.palette.warning.light
});

const linkSx = {
    textDecoration: 'none'
};

const WarningGrid = () => {
    const { data: account } = useGetIdentity();
    const translate = useTranslate();
    const { data: lastTimeEntries } = useGetList(
        'time_entries',
        {
            pagination: { page: 1, perPage: 1 },
            sort: { field: 'date', order: 'DESC' },
            filter: { user_id: account?.id }
        }
    );
    const { data: lastWeeklies } = useGetList(
        'weeklies',
        {
            pagination: { page: 1, perPage: 1 },
            sort: { field: 'date', order: 'DESC' },
            filter: { user_id: account?.id }
        }
    );

    let warningTimesheet = false;
    if (lastTimeEntries?.length > 0) {
        const lastEntryDate = lastTimeEntries[0].date;
        warningTimesheet = NOW.diff(moment(lastEntryDate), 'days') >= 7;
    }
    let warningWeekly = false;
    if (lastWeeklies?.length > 0) {
        const lastWeeklyDate = lastWeeklies[0].date;
        warningWeekly = NOW.diff(moment(lastWeeklyDate), 'days') >= 7;
    }

    return (
        <Grid container spacing={2} sx={{ marginTop: '15px' }}>
            <AdminWarningCards />
            {warningTimesheet && (
                <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                    <Link to="/time_entries/create" sx={linkSx}>
                        <Alert severity="warning" sx={cardSx}>
                            {translate('Timesheet not up to date')}
                        </Alert>
                    </Link>
                </Grid>
            )}
            {warningWeekly && (
                <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                    <Link to="/weeklies/create" sx={linkSx}>
                        <Alert severity="warning" sx={cardSx}>
                            {translate('Weekly to create')}
                        </Alert>
                    </Link>
                </Grid>
            )}
        </Grid>
    );
};

export default WarningGrid;